<script>
import { mapActions, mapGetters, mapState } from "vuex";
import i18n from "@/plugins/i18n";
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";

import axios from 'axios';
import store from '../../store';

import su1 from "../results/components/SU1Pie.vue";
import su1Heat from "../results/components/SU1Heat.vue";
import greenDeal from "../results/components/GreenDeal.vue";
import su1SubColumn from "../results/components/SU1SubColumn.vue";

import internalAnswers from "../results/components/internal-answers.vue";
import externalAnswers from "../results/components/external-answers.vue";
import internal_others from "../results/components/internal-answers_others.vue";
import internal_managers from "../results/components/internal-answers_managers.vue";
import external_others from "../results/components/external-answers_others.vue";
import external_managers from "../results/components/external-answers_managers.vue";
import external_customers from "../results/components/external-answers_customers.vue";
import materialityMatrix from "../results/components/materiality-matrix.vue";
import mixed from "../results/components/mixed.vue";

import GraphSaver from "../../components/GraphSaver.vue";

const report1 = "/images/surveys/01.png";
const report3 = "/images/surveys/03.png";
const report5 = "/images/surveys/05.png";
const report7 = "/images/surveys/07.png";
const report9 = "/images/surveys/09.png";

export default {
	components: {
		VuePdfApp,

		su1,
		su1Heat,
		greenDeal,
		su1SubColumn,

		internalAnswers,
		externalAnswers,
		internal_others,
		internal_managers,
		external_others,
		external_managers,
		external_customers,
		materialityMatrix,
		mixed,
		GraphSaver
	},

	data() {
		return {
			stepIndex: 9,
			routeToRedirect: "",

			/* the survey templates ids are concatted to the end of whichever report type is selected */
			surveysTemplate: [
				{ id: "_1", src: report1, alt: "1" },
				{ id: "_2", src: report3, alt: "2" },
				{ id: "_3", src: report5, alt: "3" },
				{ id: "_4", src: report7, alt: "4" },
				{ id: "_5", src: report9, alt: "5" },
			],

			reportLimitPasses: {
				survey_report_pass: false,
				strategy_report_pass: false,
				sustainability_report_pass: false,
			},

			myReportsItems: [],
			loadingMyReports: false,
			createMyReportModal: false,
			myReportName: "",
			myReportDescription: "",
			reportTypeSelected: "",
			reportLangSelected: "en",
			myReportNameUpdate: "",
			myReportNameUpdateBuffer: "",
			myReportDescriptionUpdate: "",
			reportTypeSelectedUpdate: "",
			myReportID: "",

			updateMyReportModal: false,
			deleteMyReportModal: false,

			su1Surveys: [],
			selectedSu1: "",

			su2Surveys: [],
			selectedSu2: "",

			initialSelected: null,
			selectedTemplate: "",

			companies: [],
			companyName: null,

			stepValidation: true,
			validationModal: false,
			validationMessage: "",

			kpiStep: null,

			planID: null,
			planActive: false,

			loading: false,

			createReportInProgress: false,
			createReportCheck: false,

			addReport: false,

			auditorCommentsModal: false,
			auditorComments: "",

			moreOptionsReport: null,
			moreOptionsSelection: null,

			reportToDeleteDirect: null,

			reportLanguageOptions: ['en', 'tr'],

			reportGraphs: [],
			reportGraphsLoading: false,
			currentGraphIndex: 0,
			graphSaveInProgress: false,

			close_create_report_timeout: null,
		};
	},

	computed: {
		...mapState('settings', [
			'process_track_id',
			'steps'
		]),

		...mapState('app', [
			'queued_jobs'
		]),

		selectedCompanyId() {
			return this.$user.company_id;
		},

		graphComponentsMap() {
			const map = [
				{
					component: su1,
					fileName: "su1_piechart.png",
					survey: 1,
					graphsName: "SDG Alignment (Pie)"
				},
				{
					component: su1Heat,
					fileName: "su1_heat.png",
					survey: 1,
					graphsName: "SDG Alignment (Heat)"
				},
				{
					component: greenDeal,
					fileName: "su1_greendeal.png",
					survey: 1,
					graphsName: "Green Deal"
				},
				{
					component: su1SubColumn,
					fileName: "su1_subcolumn.png",
					survey: 1,
					graphsName: "SDG Sub Target Alignment (Column)"
				},
				{
					component: internalAnswers,
					fileName: "su2_internalanswers.png",
					survey: 2,
					graphsName: "Internal Stakeholder Average Answers"
				},
				{
					component: externalAnswers,
					fileName: "su2_externalanswers.png",
					survey: 2,
					graphsName: "External Stakeholder Average Answers"
				},
				{
					component: mixed,
					fileName: "su2_int_ext_bar.png",
					survey: 2,
					graphsName: "Internal and External Stakeholder Average Answers"
				},
				{
					component: materialityMatrix,
					fileName: "su2_materialityMatrix.png",
					survey: 2,
					graphsName: "Materiality Matrix"
				},
				{
					component: internal_others,
					fileName: "su2_int_others.png",
					survey: 2,
					graphsName: "Internal Others Average Answers"
				},
				{
					component: internal_managers,
					fileName: "su2_int_managers.png",
					survey: 2,
					graphsName: "Internal Managers Average Answers"
				},
				{
					component: external_others,
					fileName: "su2_ext_others.png",
					survey: 2,
					graphsName: "External Others Average Answers"
				},
				{
					component: external_managers,
					fileName: "su2_ext_managers.png",
					survey: 2,
					graphsName: "External Managers Average Answers"
				},
				{
					component: external_customers,
					fileName: "su2_ext_customers.png",
					survey: 2,
					graphsName: "External Customers Average Answers"
				},
			];

			return map;
		},

		currentGraphItem() {
			if (!this.reportGraphs[this.currentGraphIndex]) return null;

			const graph_item = this.reportGraphs[this.currentGraphIndex];
			Object.assign(graph_item, { survey_id: graph_item.survey === 1 ? this.selectedSu1 : (graph_item.survey === 2 ? this.selectedSu2 : null) });

			if (graph_item.survey_id === null) return null;

			return graph_item;
		},

		reportTypeOptions() {
			if (this.planID == 2) {
				return [
					{
						text: i18n.t("myReports.createModal.surveyReport"),
						value: "survey_report",
					},
				]
			} else if (this.planID == 3) {
				return [
					{
						text: i18n.t("myReports.createModal.surveyReport"),
						value: "survey_report",
					},
					{
						text: i18n.t("myReports.createModal.strategy"),
						value: "strategy_report",
					},
				]
			} else {
				return [
					{
						text: i18n.t("myReports.createModal.surveyReport"),
						value: "survey_report",
					},
					{
						text: i18n.t("myReports.createModal.strategy"),
						value: "strategy_report",
					},
					{
						text: i18n.t("myReports.createModal.sustainabilityReport"),
						value: "sustainability_report",
					},
				]
			}
		},

		moreOptionsList() {
			return [
				{ key: 'edit_name', text: i18n.t('myReports.more_options_list.edit_name') },
				{ key: 'edit_desc', text: i18n.t('myReports.more_options_list.edit_desc') },
				{ key: 'delete', text: i18n.t('myReports.more_options_list.delete') },
				{ key: 'translate_tr', text: i18n.t('myReports.more_options_list.translate_tr') },
				{ key: 'translate_en', text: i18n.t('myReports.more_options_list.translate_en') },
				/* { key: 'reupload', text: 'Re-upload' }, */ // is for auditor stuff
			];
		},

		sustainabilityReportSelected() {
			return this.reportTypeSelected && String(this.reportTypeSelected).includes("sustainability_report");
		},

		nextButtonDisabled() {
			if (!this.reportTypeSelected || !this.selectedSu1 || !this.selectedSu2 || this.kpisNotConfirmed) {
				return true;
			} else {
				if (this.checkReportLimitPass(this.reportTypeSelected) === true) {
					return false;
				}

				const current_year = new Date().getFullYear();
				const report_lang = !this.reportLanguageOptions || this.reportLanguageOptions.length === 0 ? // if report language options somehow (is an error!) does not exist
					'en' : ( // default to 'en'
						this.reportLanguageOptions.length === 1 ? // if report language options have only one possibility
							this.reportLanguageOptions[0] : // default to that single possibility
							this.reportLangSelected // else just go with the selected report language
					);

				const idx = this.myReportsItems
					.findIndex(x => {
						const type_match = String(x.report_type).includes(this.reportTypeSelected);

						const year = new Date(x.created_on).getFullYear();
						const year_match = year === current_year;

						const status_match = x.report_status === 'downloaded' || x.report_status === 'ready' || x.report_status === null;
						const language_match = x.report_language === report_lang;

						return type_match && year_match && status_match && language_match;
					});

				return idx !== -1;
			}
		},

		reportStatusPreparingExists() {
			return this.myReportsItems.some(item => item.report_status == "gettingready");
		},

		kpisNotConfirmed() {
			if (!this.reportTypeSelected) return false;

			if (this.reportTypeSelected.includes("sustainability_report")) {
				return this.kpiStep != null;
			} else {
				return false;
			}
		},

		sanitizedSelectedLanguage() {
			return !this.reportLanguageOptions || this.reportLanguageOptions.length === 0 ? // if report language options somehow (is an error!) does not exist
				'en' : ( // default to 'en'
					this.reportLanguageOptions.length === 1 ? // if report language options have only one possibility
						this.reportLanguageOptions[0] : // default to that single possibility
						this.reportLangSelected // else just go with the selected report language
				);
		},
	},

	watch: {
		createMyReportModal(newVal, oldVal) {
			if (newVal == true && oldVal == false) {
				const report_type = this.reportTypeOptions.find(item => item.value == this.reportTypeSelected).text;
				this.myReportName = `${this.companyName} - ${report_type}`;
				this.myReportDescription = `${this.companyName} - ${report_type}`;
				this.$refs.createReportPopup.openPopup();
			}
		},

		moreOptionsSelection(val) {
			if (val === 'edit_desc') {
				this.$refs.editDescriptionPopup.openPopup();
			} else if (val === 'delete') {
				this.$refs.deleteReportPopup.openPopup();
			}
		},

		createReportCheck(val) {
			if (val === true) {
				this.$refs.createReportCheckPopup.openPopup();
			}
		},

		auditorCommentsModal(val) {
			if (val === true) {
				this.$refs.auditorCommentsPopup.openPopup();
			}
		},

		validationModal(val) {
			if (val === true) {
				this.$refs.validationPopup.openPopup();
			}
		},
	},

	beforeDestroy() {
		if (this.close_create_report_timeout != null) {
			clearTimeout(this.close_create_report_timeout);
		}
	},

	mounted() {
		this.getProcess();
		this._getCompanyLicenceState();
		this._getCompanyReportPublishingStatus();
		this._checkReportPassPermissions();

		this.setCompanyName();

		this.myReports();
		this.getMySurveySu1();
		this.getMySurveySu2();
	},

	methods: {
		...mapActions("reports", [
			"getMyReports",
			"createMyReports",
			"updateMyReports",
			"deleteMyReports",
			"checkReportPassPermissions",
			"downloadMyReport",
			"getReportGraphData",
			"resetReportGraphData",
		]),
		...mapActions("surveys", ["getSU1Surveys", "getSU2Surveys"]),
		...mapActions('settings', [
			'getProcessTrack',
			'updateProcessTrack',
		]),
		...mapActions('company', [
			'getCompanyReportPublishingStatus'
		]),

		_checkReportPassPermissions() {
			this.checkReportPassPermissions()
				.then(res => {
					this.reportLimitPasses = res.data;
				})
				.catch(err => {
					console.error(err);
				})
		},

		_getCompanyReportPublishingStatus() {
			this.getCompanyReportPublishingStatus()
				.then(res => {
					this.reportLanguageOptions = res.data.report_languages_selected;
				})
				.catch(error => {
					console.error(error);
				})
		},

		myReports() {
			this.myReportsItems = [];
			this.loadingMyReports = true;
			const params = {
				company_id: this.$user.company_id,
				is_deleted: false,
			};
			this.getMyReports(params)
				.then((res) => {
					res.data.forEach((element) => {
						if (element.report_type != "carbon_report") {
							this.myReportsItems.push(element);
						}
					});
				})
				.catch(({ response }) => {
					this.$toast.open({
						message: this.$parseResMessage(response.data.messageName),
						type: "error",
						duration: 5000,
						dismissible: true,
					});
				})
				.finally(() => {
					this.checkReportStatusExists();
					this.loadingMyReports = false;
				});
		},

		async createReportController() {
			if (this.createReportInProgress == true) {
				console.warn('There is already a report creation in process!');
				return;
			}

			if (!this.sustainabilityReportSelected && this.reportGraphs.length > 0 && this.currentGraphIndex < this.reportGraphs.length) {
				if (this.currentGraphIndex === 0) {
					console.log('There are graphs required to be confirmed by the user.');
					await this.$refs.reportGraphPopup.openPopup();
				} else {
					console.log('User needs to keep confirming a few more graphs.');
				}

				return;
			} else if (!this.sustainabilityReportSelected && this.currentGraphIndex >= this.reportGraphs.length) {
				this.$refs.reportGraphPopup.closePopup();
			}

			this.createReportCheck = true;
		},

		createReportOK() {
			this.createReportInProgress = true;
			this.addReport = false;

			const reportTypeName = this.getReportTypeName();

			this.myReportsItems.unshift({
				my_report_name: this.myReportName,
				report_type: reportTypeName,
				report_status: "gettingready",
				created_on: new Date(),
				audit_report_status: 'pending',
				auditor_comments: ''
			});

			const jobId = crypto.randomUUID();

			const params = {
				user_id: this.$user.user_id,
				my_report_name: this.myReportName,
				my_report_description: this.myReportDescription,
				report_type: reportTypeName,
				company_id: this.selectedCompanyId,
				su1_survey_id: this.selectedSu1,
				su2_survey_id: this.selectedSu2,
				report_language: this.sanitizedSelectedLanguage,
				job_id: jobId
			};

			this.$addQueuedJob({
				job_id: jobId,
				options: {
					path: '/reports',
					query: null,
					type: 'report_creation'
				},
				result: null,
			});

			this.close_create_report_timeout = setTimeout(() => {
				this.$refs.createReportPopup.startHideProcess();
			}, 30000);

			this.createMyReports(params)
				.then(res => {
					this.$notify('success', res.data.messageName);
				})
				.catch(({ response }) => {
					// No response means the request timed out or the connection dropped; the queued job still reports the outcome.
					if (response) this.$notify('error', response.data.messageName);
				})
				.finally(() => {
					// The report is ready or failed now: close the in-progress dialog (a retry starts over and re-checks
					// the graphs), allow a new report and show its real status instead of the placeholder row.
					clearTimeout(this.close_create_report_timeout);
					if (this.$refs.createReportPopup) this.$refs.createReportPopup.startHideProcess();
					this.createReportInProgress = false;
					this.myReports();
					/* const jobs = structuredClone(this.queued_jobs);
                    const idx = jobs.findIndex(x => x.job_id == jobId);
                    if (idx != -1) {
                        console.log("splicing the completed job");
                        jobs.splice(idx, 1);
						store.dispatch('app/setQueuedJobs', jobs);
                    } */
				})
		},

		//open update modal
		openUpdateDialog(data) {
			if (data.report_status === 'gettingready' || data.report_status === 'failed') return;

			this.updateMyReportModal = true;
			this.myReportNameUpdate = data.my_report_name;
			this.myReportNameUpdateBuffer = data.my_report_name;
			this.myReportDescriptionUpdate = data.my_report_description;
			this.reportTypeSelectedUpdate = data.report_type;
			this.myReportID = data.my_report_id;
		},
		updateMyReportOK() {
			this.loadingMyReports = true;
			const params = {
				my_report_id: this.myReportID,
				user_id: this.$user.user_id,
				my_report_name: this.myReportNameUpdate,
				my_report_description: this.myReportDescriptionUpdate
			};
			this.updateMyReports(params)
				.then((res) => {
					this.myReports();
					this.$notify('success', res.data.messageName);
				})
				.catch(({ response }) => {
					this.$notify('error', response.data.messageName);
				})
				.finally(() => {
					this.loadingMyReports = false;
				});
		},

		updateReportName(report) {
			const params = {
				user_id: this.$user.user_id,
				my_report_id: report.my_report_id,
				my_report_name: report.my_report_name
			}

			this.updateMyReports(params)
				.then(response => {
					this.$notify('success', response.data.messageName);
				})
				.catch(({ response }) => {
					this.$notify('error', response.data.messageName);
				})
		},

		updateReportDescription() {
			const params = {
				user_id: this.$user.user_id,
				my_report_id: this.moreOptionsReport.my_report_id,
				my_report_description: this.moreOptionsReport.my_report_description
			};

			this.updateMyReports(params)
				.then(response => {
					this.$notify('success', response.data.messageName);
				})
				.catch(({ response }) => {
					this.$notify('error', response.data.messageName);
				})
		},

		openDeleteDialog(data) {
			if (data.report_status === 'gettingready') return;

			this.deleteMyReportModal = true;
			this.myReportID = data.my_report_id;
		},

		deleteReport() {
			const params = {
				my_report_id: this.moreOptionsReport ? this.moreOptionsReport.my_report_id : this.reportToDeleteDirect.my_report_id,
				company_id: this.$user.company_id
			};

			if (!params.my_report_id) return;

			this.deleteMyReports(params)
				.then((res) => {
					this.$notify('success', res.data.messageName);
					this.myReportsItems = this.myReportsItems.filter(x => x.my_report_id != params.my_report_id);
				})
				.catch(({ response }) => {
					this.$notify('error', response.data.messageName);
				})
		},

		getMySurveySu1() {
			this.su1Surveys = [];
			this.loadingMySurveys = true;
			const params = {
				created_by: this.$user.user_id,
				company_id: this.selectedCompanyId,
				is_deleted: false,
			};
			this.getSU1Surveys(params)
				.then((res) => {
					this.su1Surveys = res.data;
					if (res.data.length > 0) {
						this.selectedSu1 = res.data[0].su1_survey_id;
					}
				})
				.catch(({ response }) => {
					this.$notify('error', response.data.messageName);
				})
				.finally(() => {
					this.loadingMySurveys = false;
				});
		},

		getMySurveySu2() {
			this.su2Surveys = [];
			const params = {
				company_id: this.selectedCompanyId,
				is_deleted: false,
				is_approved: true,
			};
			this.getSU2Surveys(params)
				.then((res) => {
					this.su2Surveys = res.data;
					if (res.data.length > 0) {
						this.selectedSu2 = res.data[0].su2_survey_id;
					}
				})
				.catch(({ response }) => {
					this.$notify('error', response.data.messageName);
				});
		},

		onSelectTemplate(template) {
			this.selectedTemplate = template.id;
		},

		async downloadReport(data) {
			if (data.report_status === 'gettingready' || data.report_status === 'failed') return;

			try {
				const requestPayload = {
					my_report_id: data.my_report_id,
					company_id: data.company_id
				};

				const response = await axios.post('/api/myreport/downloadmyreport', requestPayload, {
					responseType: 'blob',
					withCredentials: true,
				});
				const blob = new Blob([response.data], { type: 'application/msword' });
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', data.my_report_name + '.docx');
				document.body.appendChild(link);
				link.click();
				window.URL.revokeObjectURL(url);
			} catch (error) {
				this.$toast.open({
					message: error,
					type: "error",
					duration: 5000,
					dismissible: true,
				});
			}
		},
		reportTypeText(reportType) {
			if (reportType.includes("survey_report")) {
				return this.reportTypeOptions[0].text
			}
			if (reportType.includes("strategy_report") && this.reportTypeOptions.length >= 2) {
				return this.reportTypeOptions[1].text
			}
			if (reportType.includes("sustainability_report") && this.reportTypeOptions.length >= 3) {
				return this.reportTypeOptions[2].text
			}
		},

		setCompanyName() {
			this.companyName = localStorage.getItem('company_name');
		},

		async openCreateReportModal() {
			if (this.nextButtonDisabled) {
				alert(":)");
				return;
			}

			this._getReportGraphData();
			this.createMyReportModal = true;
		},

		checkReportNameExists(_name) {
			const exists = this.myReportsItems.some(item => item.my_report_name == _name);
			return exists;
		},

		checkReportLimitPass(type) {
			if (type === 'sustainability_report') {
				return this.reportLimitPasses.sustainability_report_pass;
			} else if (type === 'strategy_report') {
				return this.reportLimitPasses.strategy_report_pass;
			} else if (type === 'survey_report') {
				return this.reportLimitPasses.survey_report_pass;
			} else {
				return false;
			}
		},

		_getReportGraphData() {
			this.reportGraphs = [];
			this.reportGraphsLoading = true;
			// Every graph has an EN row ("su1_piechart") and a TR row ("su1_piechart_tr"); only the rows of the
			// report language decide what has to be captured, since the report embeds that language's files.
			const is_tr_report = this.sanitizedSelectedLanguage === 'tr';
			this.getReportGraphData({ su1: this.selectedSu1, su2: this.selectedSu2 })
				.then(res => {
					for (let i = 0; i < res.data.report_graph_data.length; i++) {
						const data = res.data.report_graph_data[i];
						const is_tr_row = data.graph_name.endsWith('_tr');
						if (data.requires_upload && is_tr_row === is_tr_report) {
							const base_name = is_tr_row ? data.graph_name.slice(0, -'_tr'.length) : data.graph_name;
							const graph_component = this.graphComponentsMap.find(x => x.fileName === base_name.concat('.png'));
							if (graph_component) this.reportGraphs.push(graph_component);
						}
					}
				})
				.catch(() => {
					console.error('Error fetching report graph data.');
				})
				.finally(() => {
					this.reportGraphsLoading = false;
				})
		},

		_resetReportGraphData() {
			this.resetReportGraphData({ su1_survey_id: this.selectedSu1, su2_survey_id: this.selectedSu2 })
				.then(() => {
					this.$notify('success', '', true);
				})
				.catch(() => {
					this.$notify('error', '', true);
				})
		},

		async takeGraphScreenshot() {
			await this.setGraphSaveInProgress(true);
			await this.$refs.graphSaver.takeGraphScreenshot();
		},

		async resetReportGraphPopup(skip_close_popup) {
			if (!skip_close_popup) await this.$refs.reportGraphPopup.closePopup()
			await this.setCurrentGraphIndex(0);
			await this.setGraphSaveInProgress(false);
			this.reportGraphs = [];
		},

		async handleCancelGraphSaver() {
			await this.$refs.reportGraphPopup.closePopup();
			await this.setCurrentGraphIndex(0);
			await this.setGraphSaveInProgress(false);
		},

		async handleGraphSaveFinish(type) {
			if (type === 'success') {
				await this.setCurrentGraphIndex(this.currentGraphIndex + 1);
				await this.createReportController();
			} else if (type === 'error') {
				return;
			}

			await this.setGraphSaveInProgress(false);
		},

		async setCurrentGraphIndex(idx) {
			this.currentGraphIndex = idx;
		},

		async setGraphSaveInProgress(bool) {
			this.graphSaveInProgress = bool;
		},

		async clickMoreOptions(report) {
			if (report && report.report_status === 'gettingready') {
				await this.setMoreOptionsReport(null);
				return;
			}

			if (this.moreOptionsSelection != null) {
				await this.setMoreOptionsSelection(null);
				await this.setMoreOptionsReport(report);
			} else if (this.moreOptionsReport === report) {
				await this.setMoreOptionsReport(null);
			} else {
				await this.setMoreOptionsReport(report);
			}
		},

		async setMoreOptionsReport(report) {
			if (report === null) {
				await this.setMoreOptionsSelection(null);
			}
			this.moreOptionsReport = report;
		},

		async clickOption(option) {
			this.setMoreOptionsSelection(option);
		},

		async setMoreOptionsSelection(option) {
			this.moreOptionsSelection = option;
		},

		async clickReportName(report, i) {
			if (report.report_status === 'gettingready' || report.report_status === 'failed') return;

			await this.setMoreOptionsReport(report);
			await this.setMoreOptionsSelection('edit_name');
			this.$refs[`report_${i}`][0].focus();
		},

		async resetOptions() {
			await this.setMoreOptionsReport(null);
			await this.setMoreOptionsSelection(null);
		},

		async clickCreateReport(bool) {
			/* if (this.reportStatusPreparingExists) {
				return false;
			} */

			this.addReport = bool;
			if (bool == false) {
				this.resetAddReport();
			}
		},

		clickDeleteReportDirect(report) {
			this.reportToDeleteDirect = report;
			this.$refs.deleteReportPopup.openPopup();
		},

		resetAddReport() {
			this.reportTypeSelected = null;
			this.selectedSu1 = null;
			this.selectedSu2 = null;
			this.myReportName = "";
		},

		async resetCreateReportModal() {
			await this.resetReportGraphPopup(true);
			this.createMyReportModal = false;
		},

		onSelectSustReport(e) {
			const val = e.target.value;
			if (String(val).includes("sustainability_report")) {
				const _kpiStep = this.steps.find(x => x.step_number == 11);
				if (_kpiStep.completed == false) {
					this.kpiStep = _kpiStep;
				}
			} else {
				this.kpiStep = null;
			}
		},

		goToPerformanceMetrics() {
			this.$router.push("/kpi-metrics");
		},

		confirmKpiData() {
			const params = {
				is_step_11_completed: true,
				updated_by: this.$user.user_id,
				reporting_process_track_id: this.kpiStep.process_track_id
			};

			this.updateProcessTrack(params)
				.then(res => {
					this.$notify('success', res.data.messageName);
				})
				.catch(({ response }) => {
					this.$notify('error', response.data.messageName);
				})
				.finally(() => {
					this.getProcess();
				})
		},

		getProcess() {
			const params = {
				company_id: this.$user.company_id,
				is_deleted: false,
			};

			this.getProcessTrack(params)
				.then(res => {
					const data = res.data[0];
					if (data.is_step_11_completed == false) {
						this.kpiStep = {
							process_track_id: data.reporting_process_track_id,
							is_completed: false
						}
					} else {
						this.kpiStep = null;
					}
				})
				.catch(err => {
					console.log(err)
				})
		},

		checkReportStatusExists() {
			const exists = this.myReportsItems.some(item => item.report_status == "gettingready")
			if (exists == true) {
				setTimeout(() => {
					this.myReports();
				}, 60000);
			}
		},

		controlAuditorCommentsModal(report) {
			if (report) {
				this.auditorComments = report.auditor_comments;
				this.auditorCommentsModal = true;
			} else {
				this.auditorComments = "";
				this.auditorCommentsModal = false;
			}
		},

		// LICENCE CONTROL //

		...mapGetters("app", ["getCompanyLicence"]),

		_getCompanyLicenceState() {
			const licence = this.getCompanyLicence();

			this.planID = licence.plan_id;
			this.planActive = licence.is_active;
		},

		getReportTypeName() {
			if (this.sustainabilityReportSelected) {
				return 'sustainability_report';
			} else if (this.reportTypeSelected && this.selectedTemplate) {
				return this.reportTypeSelected.concat(this.selectedTemplate);
			} else {
				return false;
			}
		},
	},
};
</script>

<template>
	<div class="reports-page" @keydown.esc="resetOptions()">
		<div v-if="loadingMyReports" class="loading-spinner-wrapper">
			<loading-spinner v-if="!createMyReportModal" />
		</div>

		<div class="active-section-wrapper" v-else>
			<div class="reports-table">
				<div class="reports-header-row">
					<div style="flex: 2;">
						{{ $t("myReports.header.my_report_name") }}
					</div>
					<div style="flex: 2">
						{{ $t("myReports.header.report_type") }}
					</div>
					<div>
						{{ $t("myReports.header.report_lang") }}
					</div>
					<div>
						{{ $t("myReports.header.created_on") }}
					</div>
					<div>
						{{ $t("myReports.header.report_status") }}
					</div>
					<div style="text-align: center;">
						{{ $t('auditor.status.audit_status') }}
					</div>
					<div style="text-align: center;">
						{{ $t("myReports.header.download") }}
					</div>
					<div style="text-align: center;">
						{{ $t("myReports.header.more_options") }}
					</div>
				</div>

				<div class="report-info-row" v-for="(report, index) in myReportsItems" :key="index"
					:class="{ 'no-radius': addReport }">
					<div style="flex: 2">
						<input :ref="'report_'.concat(index)" class="inline-input"
							v-if="moreOptionsReport === report && moreOptionsSelection === 'edit_name'" type="text"
							v-model="report.my_report_name" @change="updateReportName(report)">
						<div style="width: 100%;" v-else @click="clickReportName(report, index)">
							{{ report.my_report_name }}
						</div>
					</div>
					<div style="flex: 2">
						{{ reportTypeText(report.report_type) }}
					</div>
					<div>
						{{ report.report_language ? report.report_language.toUpperCase() : 'EN' }}
					</div>
					<div>
						{{ report.created_on | dateFormat }}
					</div>
					<div>
						{{ $t(`myReports.misc.${report.report_status}`) }}
					</div>
					<div class="audit-status-wrapper">
						<i v-if="report.report_audit_status === 'approved'"
							v-sust-tooltip="{ text: $t('auditor.status.approved') }"
							class="fa-regular fa-circle-check"></i>
						<i v-if="report.report_audit_status === 'disapproved'"
							v-sust-tooltip="{ text: $t('auditor.status.disapproved') }"
							class="fa-regular fa-circle-xmark"></i>
						<i v-if="report.report_audit_status === 'recheck'"
							v-sust-tooltip="{ text: $t('auditor.status.recheck') }"
							class="fa-regular fa-circle-question"></i>
						<i v-if="report.report_audit_status === 'pending' || !report.report_audit_status"
							v-sust-tooltip="{ text: $t('auditor.status.pending') }" class="fa-regular fa-clock"></i>
						<i v-if="report.auditor_comments.length > 0"
							v-sust-tooltip="{ text: $t('auditor.status.comments') }" class="fa-solid fa-comments"
							@click="controlAuditorCommentsModal(report)"></i>
					</div>
					<div class="flex-all-centered-row">
						<button class="download-report-btn" @click="downloadReport(report)"
							v-if="report.report_status != 'failed'">
							<i class="fa-solid fa-file-arrow-down"></i>
						</button>
						<button class="delete-report-btn" @click="clickDeleteReportDirect(report)" v-else>
							<i class="fa-solid fa-trash"></i>
						</button>
					</div>
					<div class="edit-delete-buttons">
						<button class="more-options-btn" tabindex="0"
							:disabled="report.report_status === 'gettingready' || report.report_status === 'failed'"
							@click="clickMoreOptions(report)" @keydown.enter="clickMoreOptions(report)">
							<i class="fa-solid fa-ellipsis"></i>
						</button>

						<div v-if="
							moreOptionsReport &&
							moreOptionsReport.my_report_id === report.my_report_id &&
							moreOptionsSelection === null
						" class="more-options-list">
							<div v-for="option in moreOptionsList" :key="option.key" tabindex="0"
								@click="clickOption(option.key)" @keydown.enter="clickOption(option.key)">
								{{ option.text }}
							</div>
						</div>
					</div>
				</div>

				<div v-if="myReportsItems.length == 0 && addReport == false" class="no-data-text">
					{{ $t('noData.text') }}
				</div>

				<div v-if="addReport" class="create-report-section">
					<div class="number-tag">
						#
					</div>

					<div class="options-section">
						<div class="groups">
							<div class="field">
								<div for="report-type-options">
									{{ $t('myReports.header.report_type') }}
								</div>
								<select name="report-type-options" class="reports-page-field"
									v-model="reportTypeSelected">
									<option :value="item.value" v-for="item in reportTypeOptions" :key="item.value">
										{{ item.text }}
									</option>
								</select>
							</div>

							<div class="field" v-if="reportLanguageOptions && reportLanguageOptions.length > 1">
								<div for="report-type-options">
									{{ $t('myReports.header.report_lang') }}
								</div>
								<select name="report-type-options" class="reports-page-field"
									v-model="reportLangSelected">
									<option :value="lang" v-for="lang in reportLanguageOptions" :key="lang">
										{{ String(lang).toUpperCase() }}
									</option>
								</select>
							</div>

							<div class="kpi-warning" v-if="kpisNotConfirmed">
								<i class="fa-solid fa-circle-exclamation"></i>
								<div class="kpi-warning-inner-ctr flex-all-centered-col">
									<div class="flex-all-centered-row">
										{{ $t('myReports.misc.confirm_kpi_warning') }}
									</div>
									<div class="warning-btn-ctr flex-all-centered-row">
										<button @click="goToPerformanceMetrics()">
											{{ $t('myReports.misc.go_to_kpi') }}
										</button>
										<button @click="confirmKpiData()">
											{{ $t('myReports.misc.confirm_kpi') }}
										</button>
									</div>
								</div>
							</div>
						</div>

						<br>
						<div class="groups">
							<div class="field">
								<div>
									{{ $t('sideBar.sustainability.sdgSurvey') }}
								</div>
								<select name="su1-survey" class="reports-page-field" v-model="selectedSu1">
									<option :value="item.su1_survey_id" v-for="item in su1Surveys"
										:key="item.su1_survey_id">
										{{ item.su1_survey_name }}
									</option>
								</select>
							</div>

							<div class="field">
								<div>
									{{ $t('sideBar.sustainability.materialitySurvey') }}
								</div>
								<select name="su2-survey" class="reports-page-field" v-model="selectedSu2">
									<option :value="item.su2_survey_id" v-for="item in su2Surveys"
										:key="item.su2_survey_id">
										{{ item.su2_survey_name }}
									</option>
								</select>
							</div>

							<div class="kpi-warning" style="color: var(--sustainfinity-navy)">
								<i class="fa-solid fa-circle-exclamation"></i>
								<div>
									{{ $t('myReports.misc.once_warning') }}
								</div>
							</div>
						</div>

						<button v-if="$user.role_id === 1" class="sust-btn sust-btn-yellow"
							@click="_resetReportGraphData()">
							{{ $t('myReports.createModal.reset_graph') }}
						</button>
					</div>

					<div class="buttons-section">

						<button class="cancel-button" @click="clickCreateReport(false)">
							{{ $t('myReports.createModal.cancel') }}
						</button>

						<button class="next-button" @click="openCreateReportModal()" :disabled="nextButtonDisabled"
							:class="{ 'disabled-button': nextButtonDisabled }">
							{{ $t('myReports.createModal.next') }}
						</button>
					</div>
				</div>

				<br>
				<button id="createMyReportsBtn" @click="clickCreateReport(true)"
					
					class="create-report-button flex-all-centered-row">
					<div>{{ $t("myReports.createModal.createReport") }}</div>
					<i class="fa-solid fa-plus"></i>
				</button>
			</div>
		</div>

		<br /><br /><br />

		<sust-popup ref="createReportPopup" 
			size="lg"
			:title="$t('myReports.createModal.createReport')" 
			:footer="false" 
			@onHide="resetCreateReportModal()"
		>
			<div v-if="!createReportInProgress" class="create-report-popup-wrapper">
				<div>
					<div class="create-report-label">
						{{ $t('myReports.createModal.reportName') }}
					</div>
					<input class="create-from-modal-field text-center" name="report-name" v-model="myReportName">
					<div class="report-exists-warning"
						v-if="myReportsItems.some(item => item.my_report_name == myReportName)">
						<i class="fa-solid fa-circle-exclamation"></i>
						{{ $t('myReports.misc.report_name_exists') }}
					</div>
				</div>

				<div>
					<div class="create-report-label">
						{{ $t('myReports.createModal.reportDescription') }}
					</div>
					<textarea class="create-from-modal-field" rows="2" name="report-description"
						v-model="myReportDescription"></textarea>
				</div>

				<div v-if="!sustainabilityReportSelected">
					<div class="create-report-label">
						{{ $t('myReports.header.report_template') }}
					</div>
					<vue-select-image :rootClass="'custom-style3'" :dataImages="surveysTemplate" :is-multiple="false"
						:selectedTemplate="initialSelected" @onselectimage="onSelectTemplate" :active-class="test">
					</vue-select-image>
				</div>

				<div>
					<button class="create-report-popup-btn"
						:disabled="createReportInProgress || reportGraphsLoading || myReportsItems.some(item => item.my_report_name == myReportName)"
						@click="createReportController()">
						{{ $t('myReports.createModal.ok') }}
					</button>
				</div>
			</div>

			<div class="flex-all-centered-col" v-else>
				<div>
					{{ $t('myReports.createModal.inProgress') }}
				</div>
				<loading-spinner style="font-size: 2em; padding: .5em;" color="var(--sustainfinity-green)" />
			</div>
		</sust-popup>

		<sust-popup ref="editDescriptionPopup" 
			size="sm" 
			:title="$t('myReports.updateModal.updateReport')"
			@onHide="clickMoreOptions(null)" 
			@ok="updateReportDescription()"
		>
			<textarea v-if="moreOptionsReport && moreOptionsSelection === 'edit_desc'" class="inline-input"
				v-model="moreOptionsReport.my_report_description" rows="3" style="min-height: 3em;"></textarea>
		</sust-popup>

		<sust-popup ref="deleteReportPopup" 
			size="xs" 
			:title="$t('myReports.deleteModal.deleteReport')"
			@ok="deleteReport()"
			@onHide="clickMoreOptions(null)"
		>
			{{ $t("myReports.deleteModal.deleteReportTitle") }}
		</sust-popup>

		<sust-popup ref="validationPopup" 
			size="md" 
			:title="$t('stepValidations.title')"
			@ok="() => $router.push(routeToRedirect)" 
			@onHide="() => validationModal = false"
			:cancelButtonText="$t('stepValidations.close')" :okButtonText="$t('stepValidations.redirect')"
		>
			{{ validationMessage }} <br /> {{ $t('stepValidations.confirmRedirect') }}
		</sust-popup>

		<sust-popup ref="auditorCommentsPopup" 
			size="md" 
			:title="$t('auditor.status.comments')"
			@onHide="controlAuditorCommentsModal(false)" :footer="false"
		>
			{{ auditorComments }}
		</sust-popup>

		<sust-popup ref="reportGraphPopup"
			:title="`${$t('myReports.createModal.confirmGraph')}: ${currentGraphIndex + 1} / ${reportGraphs.length}`"
			:footer="false"
		>
			<graph-saver v-if="currentGraphItem" 
				ref="graphSaver" 
				:graphComponent="currentGraphItem.component"
				:graphFileName="currentGraphItem.fileName" 
				:selectedSurveyID="currentGraphItem.survey_id"
				:language="sanitizedSelectedLanguage" 
				:userInfo="$user" 
				@onSuccess="handleGraphSaveFinish('success')"
				@onError="handleGraphSaveFinish('error')" 
			/>

			<div 
				class="flex-all-centered-row" 
				style="justify-content: flex-end;"
			>
				<button class="sust-btn sust-btn-red" @click="handleCancelGraphSaver()" style="margin: 0 .5em ;">
					{{ $t('userProfile.cancel') }}
				</button>
				<button class="sust-btn sust-btn-green" @click="takeGraphScreenshot()" style="margin: 0 .5em ;"
					:disabled="graphSaveInProgress">
					<span v-if="!graphSaveInProgress">
						{{ $t('userProfile.confirm') }}
					</span>
					<loading-spinner v-else />
				</button>
			</div>
		</sust-popup>

		<sust-popup ref="createReportCheckPopup" 
			:title="$t('myReports.createModal.createReport')"
			@ok="createReportOK()" 
			@onHide="() => createReportCheck = false"
		>
			{{ $t("myReports.createModal.createReportTitle") }}
		</sust-popup>
	</div>
</template>

<style scoped lang="scss">
.reports-page {
	padding: 1em;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
}

.loading-spinner-wrapper {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	font-size: 2.5em;
}

.active-section-wrapper {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
}

.reports-table {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	filter: drop-shadow(0 .25em .25em gray);
}

.reports-header-row {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: stretch;
	flex-wrap: wrap;
	align-content: flex-start;

	background-color: var(--sustainfinity-navy);
	color: whitesmoke;
	border-top-right-radius: 1.5em;
	border-top-left-radius: 1.5em;

	>div {
		padding: .5em;
		flex: 1;

		border-right: thin solid whitesmoke;

		&:last-of-type {
			border-right: 0 !important;
		}
	}
}

.report-info-row {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: flex-start;

	padding: .5em 0 .5em 0;
	color: black;
	background-color: whitesmoke;
	border-top: thin solid var(--sustainfinity-navy);

	&:last-of-type {
		border-bottom: 0 !important;
		border-bottom-left-radius: 1.5em;
		border-bottom-right-radius: 1.5em;
	}

	>div {
		padding: .5em;
		flex: 1;
	}
}

.graph-component-selector {
	padding: 1.5em;
	text-align: center;

	transition: all 100ms;
	cursor: pointer;

	&:hover {
		background-color: rgb(186, 186, 186);
	}
}

.create-report-button {
	float: left;
	border-radius: .33em;
	background: linear-gradient(to right, var(--sustainfinity-green), var(--sustainfinity-blue));
	color: white;
	padding: .5em;
	font-size: .9em;
	width: 10em !important;

	border: 0;
	outline: 0;

	&:focus {
		outline: thin solid var(--sustainfinity-navy) !important;
	}

	&:active {
		outline: .2em solid var(--sustainfinity-navy) !important;
	}

	>i {
		padding-left: .5em;
		transform: translateY(10%);
	}
}

.edit-delete-buttons {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-content: center;
	align-items: center;
	text-align: center;

	>.fa-pen-to-square {
		color: var(--sustainfinity-blue);
	}

	>.fa-trash-can {
		color: var(--invalid-input);
	}

	>i {
		font-size: 1.2em;
		transition: all 150ms;
		cursor: pointer;

		&:hover {
			filter: brightness(115%);
		}
	}

	.more-options-btn {
		display: flex;
		justify-content: center;
		align-items: center;
		border: .0001em solid black;
		border-radius: 100px;
		padding: .1em;
		width: 2em !important;
		height: 2em !important;

		background-color: 0;
		color: var(--sustainfinity-navy);

		cursor: pointer;
		transition: all 150ms;

		&:hover {
			background-color: var(--sustainfinity-blue);
			color: whitesmoke;
			border-color: lightgray !important;
		}

		&[disabled-opts] {
			pointer-events: none !important;
			background-color: rgb(226, 226, 226);
		}

		>i {
			margin: 0 !important;
			padding: 0 !important;
		}
	}

	position: relative;

	>.more-options-list {
		z-index: 999;
		position: absolute;
		right: 55%;
		top: 20%;
		transform: translateY(10%);
		background-color: whitesmoke;
		color: black;
		border: thin solid gray;
		border-radius: .5em;
		box-shadow: 0 .1em .2em .1em gray;
		width: 200px;
		overflow: hidden;

		>div {
			width: 100%;
			border-bottom: thin solid lightgray;
			padding: .25em;
			text-align: left;
			background-color: whitesmoke;

			cursor: pointer;
			transition: background-color 150ms;

			&:hover {
				background-color: lightgray;
			}
		}
	}
}

.audit-status-wrapper {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-content: center;
	align-items: center;
	text-align: center;

	>i {
		font-size: 1.2em;
	}

	.fa-circle-check {
		color: var(--sustainfinity-green);
	}

	.fa-circle-xmark {
		color: var(--invalid-input);
	}

	.fa-circle-question {
		color: var(--sustainfinity-blue);
	}

	.fa-clock {
		color: var(--sustainfinity-yellow);
	}

	position: relative;

	.fa-comments {
		position: absolute;
		right: .5em;
		top: 50%;
		transform: translateY(-50%);

		cursor: pointer;
		transition: color 150ms;

		color: var(--sustainfinity-navy);

		&:hover {
			color: var(--sustainfinity-navy--hover);
		}
	}

}

.no-radius {
	border-bottom-left-radius: 0 !important;
	border-bottom-right-radius: 0 !important;
}

.create-report-section {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-content: center;
	align-items: center;
	background-color: whitesmoke;
	border-top: thin solid darkgray;
	padding-top: .5em;
	padding-bottom: .5em;
	width: 100%;
	border-bottom-left-radius: 1.5em;
	border-bottom-right-radius: 1.5em;

	>.number-tag {
		flex: .05;
		text-align: center !important;
	}

	>.options-section {
		flex: .80;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-content: center;
		align-items: flex-start;

		>.groups {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-content: center;
			align-items: center;

			>.field {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-content: center;
				align-items: center;

				margin: .33em;

				>div {
					font-size: 1.05em;
					font-weight: bold;
					color: black;
				}

				>select,
				input {
					height: 2.5em !important;
					width: 250px !important;
					padding: .33em;
					border-radius: .5em;
				}

				>select {
					text-align: center;
					color: rgb(60, 60, 60);
				}
			}

			>.kpi-warning {
				width: 100%;
				align-self: flex-end;
				display: flex;
				flex-direction: row;
				justify-content: flex-start;
				align-items: center;

				border-radius: .25em;
				padding: 1em;
				color: var(--invalid-input);
				background-color: rgb(238, 238, 238);

				>i {
					transform: translateY(25%);
					padding-right: .5em;
					font-size: 1.5em;
				}

				>.kpi-warning-inner-ctr {
					align-items: flex-start;

					>div {
						justify-content: flex-end;

						>button {
							margin-left: 1em;
							border: 0;
							outline: 0;
							padding: .25em .5em;
							color: whitesmoke;
							border-radius: .5em;
							transition: all 150ms;

							&:first-of-type {
								background-color: var(--sustainfinity-blue);

								&:hover {
									background-color: var(--sustainfinity-blue--hover);
								}
							}

							&:nth-of-type(2) {
								background-color: var(--sustainfinity-green);

								&:hover {
									background-color: var(--sustainfinity-green--hover);
								}
							}

							&:focus {
								outline: thin solid black !important;
							}

							&:active {
								scale: .95;
							}
						}
					}

					>.warning-btn-ctr {
						margin-top: 1em;
					}
				}
			}
		}
	}

	>.buttons-section {
		flex: .35;
		align-self: flex-end;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-content: flex-end;
		align-items: flex-end;

		>button {
			padding: .1em .66em .1em .66em;
			border-radius: 100px;
			color: white;
			font-weight: bold;
			border: 0;
			outline: 0;
			width: 100px;

			transition: all 150ms;

			&:hover {
				filter: brightness(115%)
			}

			&:focus {
				outline: thin solid gray !important;
			}

			&:active {
				outline: .2em solid gray !important;
			}

			margin-left: .5em;
			margin-right: .5em;
		}

		>.next-button {
			background-color: var(--sustainfinity-green);
		}

		>.cancel-button {
			background-color: var(--invalid-input);
		}

		>.reset-button {
			background-color: var(--sustainfinity-yellow);
		}
	}
}

.report-exists-warning {
	margin-top: .5em;
	display: flex;
	align-items: flex-end;

	>i {
		color: var(--invalid-input);
		padding-right: .5em;
		transform: translateY(-5%);
	}
}

.create-from-modal-field {
	width: 100%;
	padding: .5em;
	border: 0 !important;
	outline: thin solid darkgray;
	border-radius: .35em;

	&:focus {
		outline: .125em solid black !important;
	}
}

.disabled-button {
	pointer-events: none !important;
	background-color: darkgray !important;
}

.status-button {
	background: linear-gradient(to right, var(--sustainfinity-green), var(--sustainfinity-blue));
	color: white;
	border: none;
	padding: 10px 15px;
	font-size: 14px;
	border-radius: 5px;
	display: inline-flex;
	align-items: center;
	gap: 5px;
	transition: background-color 0.3s ease;
	cursor: default;
}

.status-button:disabled {
	background: linear-gradient(to right, var(--sustainfinity-green), var(--sustainfinity-blue));
	color: white;
	opacity: 1;
}

.status-button:hover,
.status-button:active,
.status-button:focus {
	background: linear-gradient(to right, var(--sustainfinity-green), var(--sustainfinity-blue));
	;
	cursor: default;
}

#createMyReportsBtn:disabled {
	filter: grayscale(90%);
}

.create-button-alert {
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 100%;
	left: 69%;
	width: 30%;


	background-color: #28a745;
	color: white;
	padding: 10px 20px;
	border-radius: 8px;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	font-size: 15px;
	text-align: center;
}

.create-button-alert i {
	margin-right: 10px;
}

.report-interaction-disabled {
	filter: grayscale(100%);
	cursor: not-allowed;

	&:hover {
		filter: grayscale(100%) !important;
		cursor: not-allowed !important;
	}
}

.no-data-text {
	width: 100%;
	text-align: center;
	font-size: 1.5em;
	background-color: whitesmoke;
	border-bottom-left-radius: 1em;
	border-bottom-right-radius: 1em;
	padding: .5em;
}

.inline-input {
	padding: .25em;
	width: 100%;
	border-radius: .25em;
	border: 0 !important;
	outline: thin solid lightgray;

	&:focus {
		outline: thin solid gray !important;
	}
}

.create-report-popup-wrapper {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;

	>div {
		width: 100%;
		padding: 1em;

		>.create-report-label {
			text-align: center;
			width: 100%;
			font-size: 1.2em;
			font-weight: bold;
			color: black;
			padding-bottom: .25em;
		}

		>.create-report-popup-btn {
			float: right;
			background-color: var(--sustainfinity-green);
			border: 0 !important;
			outline: 0;
			border-radius: .25em;
			color: whitesmoke;
			padding: .25em .75em;

			transition: background-color 150ms;

			&:hover {
				background-color: var(--sustainfinity-green--hover);
				;
			}

			&:focus {
				outline: thin solid black !important;
			}

			&:active {
				scale: .95;
			}
		}
	}
}

.download-report-btn {
	border: 0 !important;
	outline: 0 !important;
	background-color: transparent;
	color: var(--sustainfinity-green);
	font-size: 1.25em;
	padding: .1em;

	transition: all 150ms;

	&:hover {
		color: var(--sustainfinity-green--hover);
	}

	&:focus {
		outline: thin solid var(--sustainfinity-blue) !important;
	}

	&:active {
		scale: .95;
	}
}

.delete-report-btn {
	border: 0 !important;
	outline: 0 !important;
	background-color: transparent;
	color: var(--invalid-input);
	font-size: 1.25em;
	padding: .1em;

	transition: all 150ms;

	&:hover {
		color: var(--invalid-input--hover);
	}

	&:focus {
		outline: thin solid var(--sustainfinity-blue) !important;
	}

	&:active {
		scale: .95;
	}
}
</style>